export default "__VITE_ASSET__9N2zDwI4__"